import { render, staticRenderFns } from "./CheckBook.vue?vue&type=template&id=f487051c&scoped=true&"
import script from "./CheckBook.vue?vue&type=script&lang=js&"
export * from "./CheckBook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f487051c",
  null
  
)

export default component.exports